module.exports = __webpack_public_path__ + "img/knowledge-base.7cf97a5b.svg";